import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { Home, QuizCar, QuizMot, QuizBavyrox } from '../pages';

const isBavyrox = window.location.hostname.includes('bavyrox');

export default function RoutesComponent() {
  const DefaultQuiz = isBavyrox ? QuizBavyrox : Home;

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<DefaultQuiz />} />
        <Route path="/quiz/:slug" element={<DefaultQuiz />} />

        <Route path="/quiz-car" element={<QuizCar/>} />
        <Route path="/quiz-car/:slug" element={<QuizCar/>} />

        <Route path="/quiz-mot" element={<QuizMot/>} />
        <Route path="/quiz-mot/:slug" element={<QuizMot/>} />

        <Route path="/quiz-bavyrox" element={<QuizBavyrox />} />
        <Route path="/quiz-bavyrox/:slug" element={<QuizBavyrox />} />

        <Route path="*" element={<DefaultQuiz />} />
      </Routes>
    </BrowserRouter>
  );
}
